import { Box } from "@mui/material";
import FrontIcon from "assets/car-icons/Front.png";
import BackIcon from "assets/car-icons/Back.png";
import RightIcon from "assets/car-icons/Right.png";
import LeftIcon from "assets/car-icons/Left.png";
import RoofIcon from "assets/car-icons/Roof.png";
import InteriorIcon from "assets/car-icons/Interior.png";

interface CarAngleIconProps {
    angle: string;
    size?: number;
    onClick?: () => void;
    hasImages?: boolean;
}

export default function CarAngleIcon({ angle, size = 80, onClick, hasImages = false }: CarAngleIconProps) {

    // Get the appropriate PNG image based on angle
    const getCarIconSrc = () => {
        switch (angle) {
            case "front":
                return FrontIcon;
            case "back":
                return BackIcon;
            case "right":
                return RightIcon;
            case "left":
                return LeftIcon;
            case "roof":
                return RoofIcon;
            case "interior":
                return InteriorIcon;
            case "other":
            default:
                return null;
        }
    };

    const iconSrc = getCarIconSrc();

    // If PNG images are available, use them
    if (iconSrc) {
        return (
            <Box
                onClick={onClick}
                sx={{
                    width: size,
                    height: size,
                    border: hasImages ? "2px solid #4caf50" : "2px dashed #ccc",
                    borderRadius: 2,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    cursor: onClick ? "pointer" : "default",
                    bgcolor: hasImages ? "#f1f8f4" : "#fafafa",
                    transition: "all 0.3s",
                    overflow: "hidden",
                    "&:hover": onClick ? {
                        borderColor: "primary.main",
                        bgcolor: "#e3f2fd",
                        transform: "scale(1.05)",
                    } : {},
                }}
            >
                <img
                    src={iconSrc}
                    alt={`${angle} car view`}
                    style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "contain",
                    }}
                />
            </Box>
        );
    }

    // Fallback: Simple text placeholder until PNG images are added
    return (
        <Box
            onClick={onClick}
            sx={{
                width: size,
                height: size,
                border: hasImages ? "2px solid #4caf50" : "2px dashed #ccc",
                borderRadius: 2,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                cursor: onClick ? "pointer" : "default",
                bgcolor: hasImages ? "#f1f8f4" : "#fafafa",
                transition: "all 0.3s",
                "&:hover": onClick ? {
                    borderColor: "primary.main",
                    bgcolor: "#e3f2fd",
                    transform: "scale(1.05)",
                } : {},
            }}
        >
            <span style={{ fontSize: "12px", color: "#999", textTransform: "capitalize" }}>
                {angle}
            </span>
        </Box>
    );
}
